export const AUDIT = {
    AUDIT_AMOUNT: "AUDIT_AMOUNT",
    AUDIT_CREDIT_CARD: "AUDIT_CREDIT_CARD",
    AUDIT_STATUS: "AUDIT_STATUS",
    AUDIT_SUBMITTED: "AUDIT_SUBMITTED",
    AUDIT_UPDATE: "AUDIT_UPDATE",
    AUDIT_TRANSACTION: "AUDIT_TRANSACTION",
    AUDIT_SIGNATURE: "AUDIT_SIGNATURE",
};
